import CollapsibleBody from './CollapsibleBody';

export default CollapsibleBody;
